import { CodeCreate, CodeType, ProblemType } from "@openapi";
import { codeTypeToProblemType } from "@/utils/api";

// Editor route of a cloud code, without the locale prefix.
export function cloudEditorUrl(type: CodeType, id: string): string {
    switch (type) {
        case CodeType.Logo:
            return `/logo-code?id=${id}`;
        case CodeType.LogoBlockly:
            return `/logo-blocks?id=${id}`;
        case CodeType.Python:
            return `/python-code?id=${id}`;
        case CodeType.PythonBlockly:
            return `/python-blocks?id=${id}`;
        case CodeType.PythonTurtle:
            return `/python-turtle-code?id=${id}`;
        case CodeType.PythonTurtleBlockly:
            return `/python-turtle-blocks?id=${id}`;
        case CodeType.Cpp:
            return `/cpp-code?id=${id}`;
        case CodeType.PybricksBlockly:
            return `/pybricks-blocks?id=${id}`;
        case CodeType.Pybricks:
            return `/pybricks-code?id=${id}`;
        case CodeType.Soldered:
            return `/soldered-code?id=${id}`;
        default:
            return type satisfies never;
    }
}

// The editors (code types) a problem of this type can be solved in.
export const codeTypesForProblemType = (problemType: ProblemType): CodeType[] =>
    Object.values(CodeType).filter(
        (codeType) => codeTypeToProblemType(codeType) === problemType,
    );

// A new, empty cloud code linked to a problem. Block editors start from an
// empty workspace, the same as "Create" without the example code.
export const newCodeForProblem = (
    codeType: CodeType,
    problem: { id: string; name: string },
    userId: string,
): CodeCreate => ({
    name: problem.name,
    type: codeType,
    code: "",
    user_id: userId,
    problem_id: problem.id,
    blockly_workspace: codeType.endsWith("_blockly") ? "null" : null,
});
